import usePropHelper from "../../../hooks/PropHelper";
import { Prop } from "../../../models/Prop";
import { PiInteractionDropdown } from "../../../components/PiInteractionDropdown";
import { ReactNode, useMemo } from "react";
import useAttachmentHelper from "../../../hooks/AttachmentHelper.hook";

import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import PiCreatorDropdownItem from "../../../components/PiCreatorDropdown/PiCreatorDropdownItem";
import PropIcon from "../../../icons/PropIcon";
import PiCreatorDropdown from "../../../components/PiCreatorDropdown/PiCreatorDropdown";
export default function NodeAttachPropDropdown(props: {
  onChange: (prop: Prop) => void;
  selectedPropId: string;
  accessory?: ReactNode;
}) {
  const { onChange, selectedPropId, accessory } = { ...props };
  const { getPropPresetByInstanceId } = usePropHelper();

  const { getAllAttachableProps } = useAttachmentHelper();

  const selectedPropName = useMemo(() => {
    const p = getPropPresetByInstanceId(selectedPropId);
    return p ? p.name : "No prop selected";
  }, [selectedPropId]);

  const dropdownItems = getAllAttachableProps().map((prop) => {
    return (
      <PiCreatorDropdownItem
        text={prop.name}
        icon={<ViewInArOutlinedIcon color="inherit" fontSize="inherit" />}
        onClick={() => onChange(prop)}
      />
    );
  });

  const trigger = useMemo(() => {
    return (
      <div
        className={
          "flex items-center w-full h-full font-normal gap-[10px] px-[4px] text-creator-text-sub text-[12px]"
        }
      >
        <PropIcon size={20} />
        <div className={"my-auto truncate"}>{selectedPropName}</div>
      </div>
    );
  }, [selectedPropName]);

  return (
    <div className="flex flex-col gap-[8px] noDrag nowheel">
      <div className="font-medium text-creator-text text-[14px]">Prop</div>
      <div className="flex items-center gap-[8px]">
        <div className="flex-1 min-w-0">
          <PiCreatorDropdown
            style="small"
            label={undefined}
            trigger={trigger}
            items={dropdownItems as JSX.Element[]}
          />
        </div>
        {accessory && <div className="shrink-0">{accessory}</div>}
      </div>
    </div>
  );
}
